// import fs from 'node:fs/promises';
// import path from 'node:path';

import {Generated, Kysely, sql} from 'kysely';
import {DB} from './kysely_types';
import {DataMigration} from './db/data_migrations/run_data_migrations';
import {DBObjects} from './store_types';

// import m1 from '../../db/dialects/sqlite/migrations/20241116035115_init/migration.sql';

type Migration = {
    id: Generated<number>;
    name: string;
    createdAt: Generated<string>;
};

type DBWithMigrations = DB & {
    Migration: Migration;
};

type MigrationFileSource = {
    name: string;
    getMigration: () => Promise<string>;
};

export const migrateSqliteDB = async (
    originalDB: Kysely<DB>,
    migrations: MigrationFileSource[],
    dataMigrations: DataMigration[],
    getFileSrc: (file: DBObjects['File'] & {full_path?: string}) => Promise<string>,
    decodeAudioData: (arrayBuffer: ArrayBuffer) => Promise<AudioBuffer>
) => {
    // const migrationsParentFolder = migrationsDirectory || 'db/dialects/sqlite/migrations';
    // const migrationFolders = await fs.readdir(migrationsParentFolder);

    // const migrationFiles: string[] = [
    //     // 'db/dialects/sqlite/migrations/20241116035115_init/migration.sql',
    // ];

    // for (const f of migrationFolders) {
    //     if (f.includes('.')) {
    //         continue;
    //     }

    //     const migrationFile = path.join(migrationsParentFolder, f, 'migration.sql');
    //     migrationFiles.push(migrationFile);
    // }

    const db = originalDB as unknown as Kysely<DBWithMigrations>;

    // const allMigrationFileContents = await Promise.all(migrationFiles.map(filePath => fs.readFile(filePath).then(f => f.toString())));

    await ensureMigrationsTable(db);

    const existingMigrations = await db.selectFrom('Migration').select('name').execute();

    const allMigrations = (migrations as (MigrationFileSource | DataMigration)[]).concat(dataMigrations)
    .sort((a, b) => {
        return a.name.localeCompare(b.name);
    });

    let numMigrations = 0;
    // for (const fileName of migrations) {
    for (const migration of allMigrations) {
        // const fileNameParts = fileName.split('/');
        // const migrationName = fileNameParts[fileNameParts.length - 2];

        const migrationName = migration.name;

        if (existingMigrations.find(m => m.name === migrationName)) {
            continue;
        }

        console.log(`Running migration ${migrationName}`);
        numMigrations++;

        // const migrationFileContents = (await fs.readFile(fileName)).toString();
        if ('getMigration' in migration) {
            const migrationFileContents = await migration.getMigration();

            const statements: string[] = [];
            let currentStatement = '';
            for (let i = 0; i < migrationFileContents.length; i++) {
                if (migrationFileContents[i] === ';' && migrationFileContents.substring(i + 2, i + 10) !== '--ignore') {
                    console.log('logging', migrationFileContents.substring(i + 2, i + 10))
                    statements.push(currentStatement.trim());

                    if (process.env.NODE_ENV === 'development') {
                        console.log(`Statement: ${currentStatement.trim()}`);
                    }
                    currentStatement = '';
                } else {
                    currentStatement += migrationFileContents[i];
                }
            }
            if (currentStatement.trim()) {
                statements.push(currentStatement.trim());
                if (process.env.NODE_ENV === 'development') {
                    console.log(`Statement: ${currentStatement.trim()}`);
                }
            }

            for (const statement of statements) {
                if (process.env.NODE_ENV === 'development') {
                    console.log(`Executing statement: ${statement}`);
                }
                await sql`${sql.raw(statement)};`.execute(db);
            }
        } else {
            await migration.run({db: db as unknown as Kysely<DB>, getFileSrc, decodeAudioData});
        }

        await db.insertInto('Migration').values({name: migrationName}).execute();
    }

    if (numMigrations) {
        console.log(`Ran ${numMigrations} migration${numMigrations === 1 ? '' : 's'}`);
    }
};

const ensureMigrationsTable = async (db: Kysely<DBWithMigrations>) => {
    await db.schema.createTable('Migration')
        .ifNotExists()
        .addColumn('name', 'text', (col) => col.notNull().unique())
        .addColumn('createdAt', 'text', (cb) =>
            cb.notNull().defaultTo(sql`CURRENT_TIMESTAMP`)
            // cb.notNull().defaultTo(sql`now()`)
        )
        .execute();

    // const indexColumns = ['key', 'value', 'workspace', 'store'] as const;

    // for (const colName of indexColumns) {
    //     await db.schema.alterTable('kvstore')
    //     .addIndex(colName + '__index')
    //     .column(colName)
    //     .execute();
    // }
}

export const dropAllTables = async (db: Kysely<any>) => {
    const tables = await db
        .selectFrom('sqlite_master')
        .selectAll()
        .where('type', '=', 'table')
        .where('name', 'not like', 'sqlite_%')
        .execute();

    console.log(tables);
    console.log(' ')

    await sql`${sql.raw('PRAGMA foreign_keys = OFF')};`.execute(db);

    for (const table of tables) {
      await db.schema.dropTable(table.name).execute();
    }

    await sql`${sql.raw('PRAGMA foreign_keys = ON')};`.execute(db);
  }
